import { isVue3 } from '../vue';

const getInstanceFromDirective = (vnode, bindings) => isVue3 ? bindings.instance : vnode.context;

export { getInstanceFromDirective };
